export default {
    "in": {
        translation: {
            "signIn" : "Sign In with SSO",
            "transactionHub" : "Transaction Hub",
            "shell" : "Shell",
            "shellAviationAIMS": "Shell Aviation AIMS"
      }
    }
}
